module.exports = __webpack_public_path__ + "img/thermometer-75.2737b3f0.svg";